import axios from 'axios';
import Cookies from 'js-cookie';

export default {
  namespaced: true,
  state: {
    remember: false,
    token: Cookies.get('token'),
    user: null,
  },
  getters: {
    check(state) {
      return state.token && state.user;
    },
    user(state) {
      return state.user;
    },
  },
  mutations: {
    SET_REMEMBER(state, remember) {
      state.remember = remember;
    },
    SET_TOKEN(state, token) {
      state.token = token;

      Cookies.set('token', token, { expires: state.remember ? 30 : null });
    },
    SET_USER(state, user) {
      state.user = user;
    },
  },
  actions: {
    async sendVerificationCode(_, payload) {
      return await axios.post('registration-email-verification', payload);
    },

    async sendCodeForResetPassword(_, payload) {
      return await axios.post('password/reset/email/verification', payload);
    },

    async verify(_, payload) {
      return await axios.post('registration-email-verify', payload);
    },

    async register(_, payload) {
      return await axios.post('register', payload);
    },

    async socialSignIn({ dispatch }, { provider, providerToken, firstName, lastName }) {
      const payload = { provider_token: providerToken };
      if (firstName) payload.first_name = firstName;
      if (lastName) payload.last_name = lastName;
      const { data } = await axios.post(`auth/${provider}`, payload);
      return dispatch('attempt', data.meta.token);
    },

    async resetPassword(_, payload) {
      return await axios.patch('profile/password/reset', payload)
    },

    async login({commit, dispatch}, payload) {
      const {data} = await axios.post('login', payload.credential);

      commit('SET_REMEMBER', payload.remember);

      return dispatch('attempt', data.meta.token);
    },
    async guestUpdatePassword({ dispatch }, payload) {
      const { data } = await axios.post("guest-update-password", payload);

      return dispatch("attempt", data.meta.token);
    },
    async changePassword(_, payload) {
      await axios.patch("profile/password", payload);
    },
    async updateProfile({ commit }, payload) {
      const { data } = await axios.patch("profile/info", payload);
      commit("SET_USER", data);
    },
    async updateBillingAddress({ commit }, payload) {
      const { data } = await axios.patch("profile/billing-address", payload);
      commit("SET_USER", data);
    },
    async attempt({ commit, state }, token) {
      if (token != null) {
        commit('SET_TOKEN', token);
      }

      if (!state.token) {
        return;
      }

      try {
        let { data } = await axios.get('me');
        // this.injectCustomerDataToAsyncChat(data);
        commit('SET_USER', data.data);
      } catch (e) {
        commit('SET_TOKEN', null);
        commit('SET_USER', null);
      }
    },
    async logout({ commit }) {
      return await axios.post('logout').then(() => {
        commit('SET_TOKEN', null);
        commit('SET_USER', null);
      });
    },
    /* injectCustomerDataToAsyncChat: function (data) {
      window.acquire = window.acquire || [];

      acquire.push({
        fields: {
          contact: {
            name: data.data.first_name,
            email: data.data.email,
            phone: data.data.phone,
          }
        }
      });
    },*/
  },
};
